import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fetchCategories } from "@/lib/api";
import { PageHero, Section } from "@/components/Section";

const cleanCat = (t) => t.split("Manufacturer")[0].split("Hand Tool")[0].trim() || t;

const Categories = () => {
  const [cats, setCats] = useState([]);
  useEffect(() => { fetchCategories().then(setCats); }, []);

  return (
    <>
      <PageHero
        eyebrow="Product Catalogue"
        title="All hand-tool categories"
        intro="22 product families. 100+ SKUs. From spanners and sockets to non-sparking specialty tools — explore the full range."
        breadcrumbs={<>Home / <span className="text-white">Products</span></>}
      />
      <Section>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="categories-grid">
          {cats.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              data-testid={`category-tile-${c.slug}`}
              className="jt-card group p-6 flex flex-col justify-between min-h-[200px]"
            >
              <div>
                <div className="flex items-center justify-between">
                  <div className="eyebrow">Category · {String(c.product_count).padStart(2, "0")}</div>
                  <ArrowRight className="w-4 h-4 text-[var(--jt-text-muted)] group-hover:text-[var(--jt-primary)] group-hover:translate-x-1 transition-all" />
                </div>
                <h3 className="mt-4 font-display font-black uppercase text-2xl tracking-tight leading-tight">{cleanCat(c.title)}</h3>
              </div>
              <div className="font-mono text-xs text-[var(--jt-text-muted)] mt-4">/{c.slug}</div>
            </Link>
          ))}
        </div>
      </Section>
    </>
  );
};

export default Categories;
